import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
import { ListData } from '@shared/interfaces/list-data';

@Component({
  selector: 'app-table-loader-or-empty-state',
  templateUrl: './table-loader-or-empty-state.component.html',
  styleUrls: ['./table-loader-or-empty-state.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TableLoaderOrEmptyStateComponent {
  @Input() position: 'absolute' | 'relative' = 'absolute';
  @Input() listData: ListData<unknown>;
  @Input() height = 400;
  @Input() onlyLoader = false;
  @Input() title = 'select-a-different-value-and-search-again';
  @Input() description = 'select-other-values-and-search-again';

  @HostBinding('class') get cssClass(): string[] {
    const cssClasses: string[] = [];
    const name = 'table-loader-empty-state';
    cssClasses.push(name);
    cssClasses.push(name + '--' + this.position);
    return cssClasses;
  }
}
